import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { TableCell, TableRow } from '@mui/material';

import {
    loadContractDetailsForContractId,
    loadServiceDetailsForContractId
} from '../../../../store/directusService';
import { setCurrentlySelectedParticipant } from '../../../../store/participantService';
import {
    ADVISER,
    hasRole,
    MANAGER,
    QUALITY,
    RECRUITMENT_MANAGER,
    SUPERUSER
} from '../../../../utils/userRoles';
import Button from '../../../formElements/Button';
import DDLOptionPicker from '../../../ui/pickers/DDLOptionPicker';

import classes from '../../../../commonStyles/tables.module.css';

const acceptedRoles = [ADVISER, MANAGER, QUALITY, RECRUITMENT_MANAGER, SUPERUSER];

const AddParticipantRow = ({ row, roles, type, onAddRow }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // LOCAL STATE
    const [phoneNumbers, setPhoneNumbers] = useState([]);
    const [newRowData, setNewRowData] = useState({
        contactMode: 'PRIMARY_PHONE_NUMBER',
        contactNumber: row.primaryPhoneNumber
    });
    const [isNavRequestSent, setIsNavRequestSent] = useState(false);

    // STORE STATE
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const contractDetailsById = useSelector(
        (state) => state.entities.directusService.contractDetailsById
    );
    const servicesByContractId = useSelector(
        (state) => state.entities.directusService.servicesByContractId
    );

    // USEEFFECTS
    useEffect(() => {
        if (type !== 'SMS') return;
        const numbers = [
            {
                id: 'PRIMARY_PHONE_NUMBER',
                name: row.primaryPhoneNumber
            },
            {
                id: 'SECONDARY_PHONE_NUMBER',
                name: row.secondaryPhoneNumber
            }
        ].filter((el) => el);
        setPhoneNumbers(numbers);
    }, [row]);

    useEffect(() => {
        if (isNavRequestSent && currentParticipant?.ptCode === row.ptCode) {
            if (!(currentParticipant.contractId in contractDetailsById))
                dispatch(loadContractDetailsForContractId(currentParticipant.contractId));
            if (!(currentParticipant.contractId in servicesByContractId))
                dispatch(loadServiceDetailsForContractId(currentParticipant.contractId));
        }
    }, [isNavRequestSent, currentParticipant]);

    useEffect(() => {
        if (
            isNavRequestSent &&
            currentParticipant?.ptCode === row.ptCode &&
            contractDetailsById[currentParticipant.contractId] &&
            servicesByContractId[currentParticipant.contractId]
        )
            navigate('/edit_participant');
    }, [contractDetailsById, servicesByContractId, isNavRequestSent, currentParticipant]);

    const onClickPTCode = () => {
        dispatch(setCurrentlySelectedParticipant(row));
        setIsNavRequestSent(true);
    };

    return (
        <TableRow
            hover
            className={`${classes.basicRowStripes} ${type === 'SMS' ? classes.rowHeight : ''}`}>
            <TableCell align="center" className={classes.rowLink} onClick={onClickPTCode}>
                {row.ptCode}
            </TableCell>
            <TableCell align="center">{row.firstName}</TableCell>
            <TableCell align="center">{row.lastName}</TableCell>
            <TableCell align="center">
                {type === 'SMS' ? (
                    <div className={classes.rowOptionPicker}>
                        <DDLOptionPicker
                            label={''}
                            id={'contactMode'}
                            disabled={!hasRole(acceptedRoles, roles)}
                            menuItems={phoneNumbers || []}
                            chosenName={newRowData.contactNumber}
                            chosenId={newRowData.contactMode}
                            onChange={(chosenId) => {
                                const contactNumber = phoneNumbers.find((el) => el.id === chosenId);
                                setNewRowData((prev) => ({
                                    ...prev,
                                    contactMode: chosenId || '',
                                    contactNumber: contactNumber?.name || ''
                                }));
                            }}></DDLOptionPicker>
                    </div>
                ) : (
                    <>{row.emailAddress === 'z' ? ' - ' : row.emailAddress}</>
                )}
            </TableCell>
            <TableCell align="center">
                {row.currentStatus === 'zz' ? ' - ' : row.currentStatus}
            </TableCell>
            <TableCell align="center">
                <Button
                    id="addParticipantButton"
                    customClass="noButtonMargin"
                    content="Add"
                    onClick={(e) => {
                        e.preventDefault();
                        onAddRow({
                            ...row,
                            selectedContact: type === 'SMS' ? newRowData : { contactMode: 'EMAIL' }
                        });
                    }}
                />
            </TableCell>
        </TableRow>
    );
};

export default AddParticipantRow;

AddParticipantRow.propTypes = {
    row: PropTypes.object,
    roles: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.string,
    onAddRow: PropTypes.func,
    onSelectRow: PropTypes.func,
    selectedRows: PropTypes.arrayOf(PropTypes.object)
};
